import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IDepsDesktop, TCitiesModalDesktop } from '../models';
import { withEventBus } from '../components/with-events-bus';

import { CitiesModalDesktop as Component } from './desktop';
import styles from './desktop.css';

export const CitiesModalDesktop = createWidget<IDepsDesktop, TCitiesModalDesktop>({
    styles,
})(withEventBus(Component));

export const CitiesModalDesktopWithoutEvent = createWidget<IDepsDesktop, TCitiesModalDesktop>({
    styles,
})(Component);
